export default {
  dataIterator: {
    rowsPerPageText: 'Ставки по страници:',
    rowsPerPageAll: 'Све',
    pageText: '{0}-{1} од {2}',
    noResultsText: 'Ни један запис није пронађен',
    nextPage: 'Следећа страница',
    prevPage: 'Претходна страница'
  },
  dataTable: {
    rowsPerPageText: 'Редова по страници:'
  },
  noDataText: 'Нема доступних података',
  carousel: {
    prev: 'Превиоус висуал',
    next: 'Нект висуал'
  }
}
